import Vue from 'vue'
import { OUTPERSONNUM, RESERVE, OUTPERSONDATA, VIOLATEDATA, DOMTICKETRESERVE, FLIGHTVIOLATE } from '@/store/mutation-types'
const travelBooking = {
  state: {
    outPersonNum: [],
    reserve: {},
    outPersonData: [],
    violate: {},
    domTicketReserve: {},
    flightTiolate: []
  },
  mutations: {
    SET_OUTPERSON: (state, payload) => {
      state.outPersonNum = payload
      Vue.ls.set(OUTPERSONNUM, payload)
    },
    SET_RESERVE: (state, payload) => {
      state.reserve = payload
      Vue.ls.set(RESERVE, payload)
    },
    SET_OUTPERSONDATA: (state, payload) => {
      state.outPersonData = payload
      Vue.ls.set(OUTPERSONDATA, payload)
    },
    SET_VIOLATE: (state, payload) => {
      state.violate = payload
      Vue.ls.set(VIOLATEDATA, payload)
    },
    SET_DOMTICKETRESERVE: (state, payload) => {
      state.domTicketReserve = payload
      Vue.ls.set(DOMTICKETRESERVE, payload)
    },
    SET_FLIGHTVIOLATE: (state, payload) => {
      state.flightTiolate = payload
      Vue.ls.set(FLIGHTVIOLATE, payload)
    }
  }
}
export default travelBooking



// WEBPACK FOOTER //
// ./src/store/modules/travelBooking.js